import axios from "axios";

import { URL } from "../../Utils/constant";

export async function allOk(pin) {
  return await axios.get(`http://${URL}/health`, {
    headers: {
      pin,
    },
  });
}
